<template>
  <div id="page" v-cloak>
    <div class="donation_amount">
      <div class="amount_info">
        <p class="title" @click="Dialog">钻石捐赠一起护航来啊生态<span></span></p>
        <p class="limit">{{initData.total_money}}<span>元</span></p>
        <p class="name">累计配额</p>
      </div>
    </div>
    <ul class="donate_data clear">
      <li>
        <p>今日全网捐赠</p>
        <p>{{initData.today_diamonds}}<span>枚</span></p>
      </li>
      <li>
        <p>昨日全网捐赠</p>
        <p>{{initData.yesterday_diamonds}}<span>枚</span></p>
      </li>
      <li>
        <p>总全网捐赠</p>
        <p>{{initData.total_diamonds}}<span>枚</span></p>
      </li>
    </ul>
    <div class="button clear">
      <div class="donate_now">
        <input type="button" :class="{ disabled : initData.status==1 }" :disabled="initData.status==1?true:false" @click="Donate">
        <p class="top">马上捐赠</p>
        <p class="bottom">分配倒计时：{{countDown}}</p>
      </div>
      <div class="donate_btn">
        <input class="my_donate lt" type="button" value="钻石明细" @click="openUrl()">
        <input class="my_donate_send rt" type="button" value="钻石赠送" @click="send = true">
      </div>
    </div>
    <transition name="fade">
      <div class="dialog_masking" v-if="visible">
        <div class="dialog">
          <p class="dialog_title">{{dialogTitle}}<img src="../img/close.png" alt="" @click="visible = !visible;dialogContent = ''"></p>
          <div class="dialog_content" v-html="dialogContent" v-bind:class="{ dialog_content_center : textAlignCenter}"></div>
          <div class="dialog_button clear" v-if="dialogButton">
            <input type="button" value="取消">
            <input type="button" value="确认">
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="dialog_masking" v-if="show">
        <div class="dialog">
          <p class="dialog_title">确认捐赠</p>
          <div class="dialog_content" @click="Donate">
            <div class="dialog_donate_input">
              <span>本次捐出</span>
              <div class="input">{{donateNumber}}</div>
              <input type="tel" id="input" v-model.number="donateNumber" maxlength="6" @input="inputNumber($event)">
              <span>枚</span>
            </div>
            <p class="dialog_donate_balance">（我的剩余钻石数：{{initData.user_diamonds}}个）</p>
            <p class="dialog_donate_text">来啊生态建设感谢您的捐赠和支持</p>
            <p class="dialog_donate_balance">注：每个用户每天只能捐赠一次</p>
          </div>
          <div class="dialog_button clear">
            <input type="button" value="取消" @click="show=false;donateNumber=0">
            <input type="button" value="确认" @click="donateDiamonds">
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="dialog_masking" v-if="send">
        <div class="dialog">
          <p class="dialog_title">钻石赠送</p>
          <div class="dialog_content">
            <div class="code_input">
              <span>好友邀请码：</span>
              <input type="tel" id="input" v-model.number="invitationCode" placeholder="请输入邀请码" maxlength="8">
            </div>
            <div class="code_input">
              <span>赠送数量：</span>
              <input type="tel" id="input" v-model.number="donateSendNum" placeholder="请输入数量" @input="inputSendNum($event)">
            </div>
            <p class="dialog_donate_balance">（我的剩余钻石数：<span class="donate_number">{{initData.user_diamonds}}</span>个）</p>
            <p class="dialog_donate_balance hint">注：一经赠送不可退回</p>
          </div>
          <div class="dialog_button clear">
            <input type="button" value="取消" @click="send=false;donateSendNum='';invitationCode='';">
            <input type="button" value="确认" @click="donateSend">
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'DiamondDonation',
    data() {
      return {
        userId: '',
        H5Key: '',
        md5: '',
        initData: {},
        visible: false,
        show: false,
        send: false,
        dialogTitle: '捐赠说明',
        dialogButton: false,
        textAlignCenter: false,
        dialogContent: "",
        givingInstructions: "<p>钻石护航来啊生态，在来啊生态的用户享受生态建设带来的福利。我们始终不忘初心，【秉着人人共建，人人收益，不充值，不让用户花一分钱】做这个活动。</p></br><p>1、钻石可以通过AR捉妖后产出；</br>2、每日配额会有变动，最终以显示界面为准；</br>3、当天捐赠钻石将在次日14：00结算分配所得，具体分配公式：当天用户捐赠钻石数量/当天所有捐赠钻石数量*当天配额；</br>4、若个人分配所得小于0.01元，则以0元结算；</br>5、活动处于试运行阶段，后期视效果决定是否长期开放；</br>6、参与活动则代表接受此活动规则，且活动最终解释权归来啊官方所有；</p>",
        countDown: '00:00:00',
        donateNumber: 0,
        invitationCode: '',
        donateSendNum: '',
      }
    },
    mounted() {
      if (window.LaiaJs) {
        window.LaiaJs.setTitle('钻石捐赠');
        this.userId = window.LaiaJs.getUserId();
        this.H5Key = window.LaiaJs.getH5Key();
        this.md5 = this.$md5(this.H5Key);
      } else {
        this.userId = '503a84e4f4374ec5916db6086bbe7b71';
        this.H5Key = 'UpSzXt4t5tSwTD2uYqVC1vPxVA1DWAWq';
        this.md5 = this.$md5(this.H5Key);
      }
      this.initialization();
      this.timeDown();
    },
    methods: {
      initialization() {
        this.$axios.post("user/getDonateDiamondsData.do", {
          "user_id": this.userId,
          "sign": this.md5,
        }).then((res) => {
          // console.log(res);
          if (res.data.Error != "") {
            if (window.LaiaJs) {
              window.LaiaJs.showMsg(res.data.Error);
              return;
            } else {
              alert(res.data.Error);
              return;
            }
          }
          this.initData = res.data;
        }).catch((e) => {
          //联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          console.log(e);
        })
      },
      // 确认赠送
      donateSend() {
        if(this.invitationCode == ''){
          if (window.LaiaJs) {
            window.LaiaJs.showMsg('请输入好友邀请码！');
            return;
          } else {
            alert('请输入好友邀请码！');
            return;
          }
        } else if(this.donateSendNum <= 0 || this.donateSendNum > this.initData.user_diamonds ){
          if (window.LaiaJs) {
            window.LaiaJs.showMsg('请输入赠送数量！');
            return;
          } else {
            alert('请输入赠送数量！');
            return;
          }
        }
        this.$axios.post("user/giveDiamonds.do", {
          "user_id": this.userId,
          "sign": this.md5,
          "diamonds": this.donateSendNum,
          "taker_cb_id": this.invitationCode,
        }).then((res) => {
          console.log(res);
          if (res.data.Error != "") {
            if (window.LaiaJs) {
              window.LaiaJs.showMsg(res.data.Error);
              return;
            } else {
              alert(res.data.Error);
              return;
            }
          }
          this.initialization();
          this.send = false;
          this.donateSendNum = '';
          this.invitationCode = '';
          if (window.LaiaJs) {
            window.LaiaJs.showMsg('赠送成功');
            return;
          } else {
            alert('赠送成功');
            return;
          }
        }).catch((e) => {
          //联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          console.log(e);
        })
      },
      // 确认捐赠
      donateDiamonds() {
        if(this.donateNumber <= 0 || this.donateNumber > this.initData.user_diamonds ){
          if (window.LaiaJs) {
            window.LaiaJs.showMsg('请输入捐赠数量！');
            return;
          } else {
            alert('请输入捐赠数量！');
            return;
          }
        }
        this.$axios.post("user/donateDiamonds.do", {
          "user_id": this.userId,
          "sign": this.md5,
          "diamonds": this.donateNumber,
        }).then((res) => {
          console.log(res);
          if (res.data.Error != "") {
            if (window.LaiaJs) {
              window.LaiaJs.showMsg(res.data.Error);
              return;
            } else {
              alert(res.data.Error);
              return;
            }
          }
          this.initialization();
          this.show = false;
          this.donateNumber = 0;
          if (window.LaiaJs) {
            window.LaiaJs.showMsg('捐赠成功');
            return;
          } else {
            alert('捐赠成功');
            return;
          }
        }).catch((e) => {
          //联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          console.log(e);
        })
      },
      // 输入
      inputNumber(e) {
        e.target.value = this.donateNumber;
        if(this.donateNumber == ''){
          this.donateNumber = 0;
        }else if(e.target.value > this.initData.user_diamonds){
          this.donateNumber = e.target.value = e.target.value.substr(0, e.target.value.length - 1).length<=0?0:e.target.value.substr(0, e.target.value.length - 1);
          if (window.LaiaJs) {
            window.LaiaJs.showMsg('余额不足！');
            return;
          } else {
            alert('余额不足！');
            return;
          }
        }
      },
      // 输入
      inputSendNum(e) {
        e.target.value = this.donateSendNum;
        if(this.donateSendNum == ''){
          this.donateSendNum = 0;
        }else if(e.target.value > this.initData.user_diamonds){
          this.donateSendNum = e.target.value = e.target.value.substr(0, e.target.value.length - 1).length<=0?0:e.target.value.substr(0, e.target.value.length - 1);
          if (window.LaiaJs) {
            window.LaiaJs.showMsg('余额不足！');
            return;
          } else {
            alert('余额不足！');
            return;
          }
        }
      },
      // 捐赠弹窗
      Donate() {
        this.show = true;
        this.$nextTick(() => {
          document.getElementById("input").focus();
        })
      },
      // 弹窗
      Dialog() {
        this.dialogContent = this.givingInstructions;
        this.visible = !this.visible;
      },
      // 倒计时
      timeDown() {
        var _this = this;
        var nowDate = new Date();
        var endDate = new Date();
        endDate.setHours(14, 0, 0, 0);
        if (nowDate.getHours() >= 14) {
          endDate.setDate(endDate.getDate() + 1);
        }
        var totalSeconds = parseInt((endDate - nowDate) / 1000);
        var days = Math.floor(totalSeconds / (60 * 60 * 24));
        var modulo = totalSeconds % (60 * 60 * 24);
        var hours = Math.floor(modulo / (60 * 60));
        modulo = modulo % (60 * 60);
        var minutes = Math.floor(modulo / 60);
        var seconds = modulo % 60;
        this.countDown = hours + "小时" + minutes + "分钟" + seconds + "秒";
        setTimeout(function() {
          _this.timeDown();
        }, 1000)
      },
      // 跳转
      openUrl(url) {
        if(window.LaiaJs){
          window.LaiaJs.openUrl('http://laia-common.yeedian365.com/laia_h5/index.html#/DiamondDonationRecord');
        }else{
          this.$router.push({
            path: '/DiamondDonationRecord',
          }).catch(err => {
            console.log(err)
          })
        }
      },
    }
  }
</script>

<style scoped>
  [v-cloak] {
    display: none;
  }

  #page {
    width: 100%;
    height: 100vh;
    background-color: #eaf1f7;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s
  }

  .fade-enter,
  .fade-leave-to

  /* .fade-leave-active in <2.1.8 */
    {
    opacity: 0
  }

  .donation_amount {
    /* position: relative;
    top: -1rem; */
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 100%;
    height: 7.52rem;
    background: url(../img/diamond_donation_bg.png) no-repeat center;
    background-size: 9.84rem 7.52rem;
    background-color: #4178fa;
  }

  .amount_info {
    width: 9.84rem;
    height: 5rem;
    text-align: center;
    border-top-left-radius: 0.2rem;
    border-top-right-radius: 0.2rem;
    margin: 0 auto;
    background-color: #fff;
  }

  .amount_info .title {
    height: 1.17rem;
    line-height: 1.17rem;
    margin-left: 0.5rem;
    margin-right: 0.4rem;
    margin-top: 0.45rem;
    padding-left: 1.4rem;
    background: url(../img/logo.png)no-repeat left center;
    background-size: 1.17rem;
    font-size: 0.52rem;
    font-weight: 200;
    letter-spacing: 0.06rem;
    color: #3f4758;
    text-align: left;
  }

  .amount_info .title span {
    float: right;
    width: 0.48rem;
    height: 1.17rem;
    background: url(../img/describe.png)no-repeat left center;
    background-size: 0.48rem;
  }

  .amount_info .limit {
    font-size: 1.2rem;
    font-weight: bold;
    color: #3771fa;
    margin-top: 0.1rem;
  }

  .amount_info .limit span {
    font-size: 0.48rem;
    font-weight: 400;
  }

  .amount_info .name {
    font-size: 0.48rem;
    color: #3f4758;
    font-weight: 300;
    letter-spacing: 1px;
  }

  .donate_data {
    width: 100%;
    height: 2.56rem;
    box-shadow: 0 -0.1rem 0.43rem 0.14rem rgba(65, 120, 250, 0.1);
    background-color: #fff;
    position: relative;
    z-index: 999;
  }

  .donate_data li {
    width: 33.33%;
    padding-top: 0.6rem;
    float: left;
    text-align: center;
    color: #3f4758;
  }

  .donate_data li p:first-child {
    font-size: 0.36rem;
  }

  .donate_data li p:last-child {
    font-size: 0.54rem;
    font-weight: bold;
    margin-top: 0.1rem;
  }

  .donate_data li p:last-child span {
    font-size: 0.36rem;
    font-weight: initial;
  }

  .button {
    margin-top: 1rem;
    padding: 0 0.48rem;
  }

  .donate_btn{
    margin-top: 0.2rem;
  }

  .my_donate,.my_donate_send{
    height: 1.41rem;
    width: 4.82rem;
    font-size: 0.42rem;
    color: #3771fa;
    border: 1px solid #3771fa;
    border-radius: 0.06rem;
  }
  .my_donate_send{
    color: #fff;
    background-color: #3771fa;
  }
  .donate_now {
    position: relative;
    width: 100%;
    height: 1.41rem;
    font-size: 0.42rem;
    text-align: center;
    color: #fff;
  }
  .donate_now input{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #3771fa;
    border-radius: 0.06rem;
  }
  .donate_now .disabled{
    opacity: 0.5;
  }
  .donate_now .top {
    position: relative;
    z-index: 9999;
    font-size: 0.48rem;
    padding-top: 0.12rem;
    pointer-events: none;
  }

  .donate_now .bottom{
    position: relative;
    z-index: 9999;
    width: 100%;
    font-size: 0.32rem;
    pointer-events: none;
  }

  .code_input{
    margin-top: 0.4rem;
    font-size: 0.46rem;
    text-align: center;
  }
  .code_input span{
    display: inline-block;
    width: 3rem;
    text-align: right;
  }
  .code_input input{
    width: 4rem;
    border-bottom: 1px solid #999;
    text-indent: 0.06rem;
  }
  .dialog_donate_input {
    margin-top: 0.1rem;
    font-size: 0.46rem;
    text-align: center;
  }

  .dialog_donate_input input {
    position: absolute;
    width: 10rem;
    opacity: 0;
    z-index: -9999;
  }

  .dialog_donate_input .input {
    width: max-content;
    display: inline-block;
    font-size: 0.8rem;
  }
  .dialog_donate_balance{
    margin-top: 0.3rem;
    font-size: 0.34rem;
    text-align: center;
  }
  .dialog_donate_text{
    margin-top: 1rem;
    margin-bottom: 0.3rem;
    font-size: 0.48rem;
    color: #8a8d97;
    text-align: center;
  }
  .dialog_content .dialog_donate_balance .donate_number{
    color: #3671fa;
  }
  .dialog_content .hint{
    color: #ff5555;
  }
</style>



// WEBPACK FOOTER //
// src/pages/TestDiamondDonation.vue